import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { clearCart, getCartFromLocalStorage } from '../utils/cartUtils';
import { resolveOrderEmail } from '../utils/orderUtils';

const Cart = () => {
  const location = useLocation();
  const [cartProducts, setCartProducts] = useState(() => getCartFromLocalStorage());
  let { userDetails = {}, finalAmount, orderId, email, mobile } = location.state || {};

  try {
    userDetails = location.state?.userDetails || JSON.parse(localStorage.getItem('userDetails')) || {};
  } catch (error) {
    userDetails = location.state?.userDetails || {};
  }

  orderId = orderId || localStorage.getItem('customOrderId') || '';
  email = resolveOrderEmail(location.state || {}, userDetails, JSON.parse(localStorage.getItem('userDetails') || '{}')) || email || '';
  mobile = mobile || userDetails.mobile || '';
  const navigate = useNavigate();

  useEffect(() => {
    // Sync cartProducts with localStorage on mount
    setCartProducts(getCartFromLocalStorage());
  }, []);

  const handleProceedToOrderSummary = () => {
    alert('Order placed successfully!');
    // Clear cart using utility function
    clearCart();
    navigate('/order-summary', {
      state: {
        products: cartProducts,
        userDetails,
        finalAmount,
        orderId,
        email: email,
        mobile: mobile,
        additionalPhone: '',
      },
    });
  };

  const filteredProducts = cartProducts.filter(product => product.quantity > 0);

  return (
    <div className="container mt-4">
      <h2>Your Cart</h2>
      <p><strong>Name:</strong> {userDetails.name}</p>
      <p><strong>Email:</strong> {email}</p>
      <p><strong>Mobile:</strong> {mobile}</p>
      <p><strong>Address:</strong> {userDetails.address}</p>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>No</th>
            <th>Product Name</th>
            <th>Quantity</th>
            <th>Total Amount</th>
          </tr>
        </thead>
        <tbody>
          {filteredProducts.map((prod, idx) => (
            <tr key={prod.no}>
              <td>{idx + 1}</td>
              <td>{prod.product_name}</td>
              <td>{prod.quantity}</td>
              <td>₹{prod.total_amount}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <p style={{
  fontSize: '1.5rem',
  fontWeight: 'bold',
  color: '#FF4500',
  backgroundColor: '#FFF3CD',
  padding: '10px',
  borderRadius: '5px',
  display: 'inline-block',
  marginTop: '20px'
}}><strong>Final Amount:</strong> ₹{finalAmount || 0}</p> {/* Display final amount */}
      
      {filteredProducts.length > 0 && (
        <div className="mt-3">
          <button 
            className="btn btn-primary" 
            onClick={handleProceedToOrderSummary}
          >
            Proceed to Order Summary
          </button>
        </div>
      )}
    </div>
  );
};

export default Cart;